import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ensureBodyScrollUnlockedIfIdle } from "../../utils/bodyScrollLock";

export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    // 带 product 参数时由产品页自己滚到对应机型，避免先回顶再抢滚动
    if (params.get("product")) {
      ensureBodyScrollUnlockedIfIdle();
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    ensureBodyScrollUnlockedIfIdle();
  }, [pathname, search]);

  return null;
}
